const matchValidate = (value: string, wannabeValue: string) => {
  let errMsg = undefined;

  if (value !== wannabeValue) {
    errMsg = "Password does not match.";
  }

  return errMsg;
};

export default matchValidate;
